import { LowerCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

import { SafeUrlPipe } from '../../sdk/pipes';

@Component({
  selector: 'rms-flag-icon',
  imports: [LowerCasePipe, MatIconModule, SafeUrlPipe],
  template: `
    @if (countryCode && !hasError) {
      <!-- FlagCDN doesn't support UK code, so we need to flip it to GB -->
      @let flag = (countryCode === 'UK' ? 'GB' : countryCode) | lowercase;
      <img
        [src]="flagUrl + flag + '.svg' | safeUrl"
        [width]="width"
        (error)="hasError = true"
        alt="flag-{{ countryCode }}" />
    } @else {
      <span>
        <mat-icon
          class="icon-sm"
          svgIcon="remix:Business/flag-line" />
      </span>
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlagIconComponent {
  @Input() public countryCode?: string | null;
  @Input() public width = 24;
  public readonly flagUrl = 'https://flagcdn.com/';
  public hasError = false;
}
